import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import AOS from 'aos';

var scroH;
let viewH = $(window).height();

$(document).scroll(function () {
  scroH = $(document).scrollTop(); //滚动高度

  // banner位移效果
  $('.section1 .bg').css({
      'transform':'translateY('+ scroH / 3 +'px)'
  })

  caixian()

  // tab浮动
  let secTop = $('.section4').offset().top
  if( scroH >= secTop){
    $('.section4').addClass('fixed')
    $('.header').addClass('trans')
  }else{
    $('.section4').removeClass('fixed')
    $('.header').removeClass('trans')
  }

  cont3ani()

})

$(document).ready(function(){
  setTimeout(function(){
    AOS.init({
      disable: false,
      duration: 500,
      offset: 30,
      easing: 'ease-in-out-sine'
    });
  },300)
  huoqu_li_top(); // 获取li 距顶部高度
  getTabH()
  getImgH()
  getSwiperH()
  
  // tab切换
  let currentUrl = document.location.href;

  $('.section4 .tab .item').eq(0).addClass('active')
  $('.section5 .swiper .swiper-slide').eq(0).addClass('swiper-slide-active')
  let sec5H = $('.section5 .swiper .swiper-slide-active').attr('data-h')
  $('.section5 .swiper').css('height',sec5H + 'px')

  $('.section4 .tab .item').on('click',function(){
    // 修改url
    let id = $(this).attr('data-id')
    if(currentUrl.indexOf('#') < 0){
      history.replaceState({}, '', currentUrl+'#'+id);
    }else{
      history.replaceState({}, '', currentUrl.split('#')[0]+'#'+id);
    }
    // 切换内容
    let index = $(this).index()
    $(this).addClass('active').siblings().removeClass('active')
    $('.section5 .swiper .swiper-slide').eq(index).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active')
    let sec5H = $('.section5 .swiper .swiper-slide-active').attr('data-h')
    $('.section5 .swiper').css('height',sec5H + 'px')
    $(document).scrollTop($('.section4').offset().top + 1)
    AOS.refreshHard()
    //其他视频暂停播放
    let other_video = $('.section5 .swiper-slide').eq(index).siblings().find('.cont5 video')
    other_video.each(function(index,item){
      item.pause()
    })
  })

  // url带有#数字则模拟点击切换
  let tab_id = currentUrl.split('#')[1]
  $('.section4 .tab .item[data-id='+ tab_id +']').trigger('click')


  $('.section5 .cont5 .play-icon').on('click',function(){
    $(this).closest('.video').addClass('active')
    let video = $(this).siblings('video')[0]
    video.play()
  })
 
})

$(window).on('load', function () {
  getSwiperH()
  let sec5H = $('.section5 .swiper .swiper-slide-active').attr('data-h')
  $('.section5 .swiper').css('height',sec5H + 'px')
})
window.onresize = function(){
  AOS.refresh()
  viewH = $(window).height();
  huoqu_li_top(); // 获取li 距顶部高度

  getTabH()
  getImgH()
  getSwiperH()
  let sec5H = $('.section5 .swiper .swiper-slide-active').attr('data-h')
  $('.section5 .swiper').css('height',sec5H + 'px')
}

// 获取li 距顶部高度
function huoqu_li_top(){
  var lc_li = $('.section2 .lc');
  for (var z = 0; z < lc_li.length; z++) {
    var lc_li_top = $('.section2 .lc:eq('+z+')').offset().top;
    $('.section2 .lc:eq('+z+')').attr('data-top',lc_li_top);
  }
}

// 动态线
function caixian(){
  var lc_li = $('.section2 .lc')

  for (var y = 0; y < lc_li.length; y++) {
    var data_top = $('.section2 .lc:eq('+y+')').attr('data-top');

    if($(window).width() >= 991){
      var banping = viewH/2;
    }else{
      var banping = viewH/3;
    }

    if( data_top != 0){
      if(scroH >= (data_top - banping)){
        var li_h = scroH - (data_top - banping);
        var li_hh = $('.section2 .lc:eq('+y+')').innerHeight();
        $('.section2 .lc:eq('+y+')').addClass('active');
        if(li_h >= li_hh){
          $('.section2 .lc:eq('+y+') .line span').css('height',li_hh);
        }else{
          $('.section2 .lc:eq('+y+') .line span').css('height',li_h);
        }
      }else{
        $('.section2 .lc:eq('+y+') .line span').css('height','0');
        $('.section2 .lc:eq('+y+')').removeClass('active');
      }
    }
  }
}


//获取tab高度
function getTabH(){
  let tabH = $('.section4 .sec-tab').outerHeight()
  $('.section4').css('height', tabH + 'px')
}
//获取swiper各个子项高度
function getSwiperH(){
  let $el = $('.section5 .swiper .swiper-slide')
  $el.each(function(index,item){
    let itemH = $(item).outerHeight()

    $(item).attr('data-h', itemH)
  })
}

//获取各个浮动图片区域高度
function getImgH(){
  if($(window).width() <= 1024){
    return
  }

  let $el = $('.section5 .cont3 .fixed-cont')

  $el.each(function(index,item){
    let itemH = $(item).find('.img').height()
    $(item).closest('.cont3').css('height',itemH + 'px')
  })
}

// img浮动变暗
function cont3ani(){
  if($(window).width() <= 1024){
    return
  }

  let $el = $('.section5 .cont3')
  
  $el.each(function(index,item){
    let itemH = (viewH - $(item).height()) / 2
    let itemTop = $(item).offset().top
    
    if(scroH > itemTop - itemH){
      $(item).addClass('fixed').find('.fixed-cont').css({
        'top': itemH + 'px',
        'opacity': 1 - (scroH - itemTop + itemH) / 1000,
        'filter': 'blur('+ (scroH - itemTop + itemH) / 300 +'px)'
      })
    }else{
      $(item).removeClass('fixed').find('.fixed-cont').css({
        'top': 0 + 'px',
        'opacity': 1,
        'filter': 'blur(0px)'
      })
    }

  })
}